export const OWNER_ROLE = "shop_owner"
export const MANAGER_ROLE = "shop_manager"
export const BASIC_ROLE = "shop_basic"
export const COMPANY_OWNER = "company_owner"
export const NATIONAL_MANAGER = "national_manager"
export const REGIONAL_MANAGER = "regional_manager"